import { render } from 'solid-js/web';
import '../public/css/bootstrap.min.css';
import '../public/css/elegantIcons.css';
import '../public/css/modern.css';
import './app.css';
// photoswipe.js is dynamically imported by PhotoGallery on demand.
import { applyMobileSocialLinks } from './socialLinks';
import { initCleptaRuntime } from './cleptaRuntime';
import { installAutoRefresh } from './state/appRefresh';
import { App } from './AppRoot';
import type { Bootstrap } from './types';

applyMobileSocialLinks();
initCleptaRuntime();

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {});
    });
}

const bootstrap: Bootstrap | undefined = window.__BOOTSTRAP__;
const mount = document.getElementById('solid-root');

// Only take over the page when the server has opted-in by emitting bootstrap
// data. Without it, Symfony/Twig owns this route and links must work normally.
if (mount && bootstrap) {
    // Wipe the server-rendered SEO/no-JS shell before Solid takes over.
    // solid-js/web `render()` appends; without this the SEO shell would
    // sit alongside the Solid output (e.g. duplicated hero header).
    mount.replaceChildren();
    render(() => <App bootstrap={bootstrap} />, mount);
    // Refresh page data automatically when returning to the app after a while.
    installAutoRefresh();
}
